
import starBucks from '../../assets/images/cafe/starBucks.webp'
import highness from '../../assets/images/cafe/highness.webp'
import hatti from '../../assets/images/cafe/hatti.webp'
import society from '../../assets/images/cafe/society.webp'
import blue from '../../assets/images/cafe/blue.webp'
import subway from '../../assets/images/cafe/subway.webp'
import barista from '../../assets/images/cafe/barista.webp'
import cafeBrew from '../../assets/images/cafe/cafeBrew.webp'

export const CafeList = {
  cafe1: () => {
    return (
      <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={starBucks} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">STARBUCKS</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Coffee</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FLAT WHITE</td>
  <td class="ft-Wt-700">290</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">CAFÉ MOCHA (WITHOUT CREAM)</td>
  <td class="ft-Wt-700">330</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">CAFÉ LATTE</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">260</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">CAFÉ AMERICANO</td>
  <td class="ft-Wt-700">260</td>
  <td class="ft-Wt-700">237ml</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Tea</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">EMPEROR'S CLOUD MIST (GREEN TEA)</td>
  <td class="ft-Wt-700">310</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">CHAI TEA LATTE</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">237ml</td>
</tr>

<tr>
  <td colspan="3">ENGLISH BREAKFAST TEA (BLACK TEA)</td>
  <td class="ft-Wt-700">310</td>
  <td class="ft-Wt-700">237ml</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Frappuccino / Cold Coffee</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">JAVACHIP FRAPPUCCINO (WITHOUT CREAM)</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">354ml</td>
</tr>

<tr>
  <td colspan="3">CARAMEL FRAPPUCCINO (WITHOUT CREAM)</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">354ml</td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">354ml</td>
</tr>

<tr>
  <td colspan="3">MOCHA FRAPPUCCINO (WITHOUT CREAM)</td>
  <td class="ft-Wt-700">370</td>
  <td class="ft-Wt-700">354ml</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">HAWAIIAN VEG CLUB SANDWICH</td>
  <td class="ft-Wt-700">410</td>
  <td class="ft-Wt-700">185gm</td>
</tr>



<tr>
  <td colspan="3">SPINACH N CORN SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">140gm</td>
</tr>





<tr>
  <td colspan="3">PANEER TIKKA SANDWICH</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">185gm</td>
</tr>

<tr>
  <td colspan="3">BLUEBERRY MUFFIN</td>
  <td class="ft-Wt-700">340</td>
  <td class="ft-Wt-700">120gm</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Rtd / Rte</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALMONDS</td>
  <td class="ft-Wt-700">185</td>
  <td class="ft-Wt-700">50gm</td>
</tr>

<tr>
  <td colspan="3">CASHEWS</td>
  <td class="ft-Wt-700">185</td>
  <td class="ft-Wt-700">50gm</td>
</tr>

<tr>
  <td colspan="3">ABC JUICE</td>
  <td class="ft-Wt-700">275</td>
  <td class="ft-Wt-700">250ml</td>
</tr>

<tr>
  <td colspan="3">ORANGE JUICE</td>
  <td class="ft-Wt-700">275</td>
  <td class="ft-Wt-700">250ml</td>
</tr>
        </table>
    );
  },
  cafe2: () => {
    return (
      <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={highness} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HIGHNESS PANINI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks & Bakery</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MEXICAN (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">200 Gms</td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">200 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE MELT PANINI (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">250 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE MAYO GARLIC BREAD</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">120 Gms</td>
</tr>

<tr>
  <td colspan="3">VEG GRILLED SANDWICH (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">280 Gms</td>
</tr>

<tr>
  <td colspan="3">MELTED SANDWICH (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">280 Gms</td>
</tr>

<tr>
  <td colspan="3">MASKA BUN</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">50 Gms</td>
</tr>

<tr>
  <td colspan="3">JAM BUN</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">50 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE CHILLY SANDWICH</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">250 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Pizza</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MARGARITA PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">140 Gms</td>
</tr>

<tr>
  <td colspan="3">PEPPY PANEER PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 Gms</td>
</tr>

<tr>
  <td colspan="3">FARMHOUSE PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Roll</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA ROLL</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700">150 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Beverages</td>
  <td></td>
  <td></td>
</tr>



<tr>
  <td colspan="3">MASALA TEA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">BLACK TEA</td>
  <td class="ft-Wt-700">50</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">LEMON TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">GREEN TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">COFFEE</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">CAFE AMERICANO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr>
  <td colspan="3">EXPRESSO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">SIGNATURE MOCHA COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">SIGNATURE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">SIGNATURE ICE AMERICANO</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">LEMON ICED TEA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">PEACH ICED TEA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>
        </table>
    );
  },
  cafe3: () => {
    return (
       <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={cafeBrew} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">CAFE BREW STUDIO</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">CAFÉ LATTE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">CAFÉ MOCHA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">AMERICANO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">HOT CHOCOLATE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">MASALA TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">140</td>
</tr>


<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300</td>
</tr>

<tr>
  <td colspan="3">ICE CHOCOLATE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">300</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Sandwich</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VEG GRILLED SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">VEG CHEESE GRILLED S/W (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">150</td>
</tr>



<tr>
  <td colspan="3">BBQ PANEER WRAP</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">210</td>
</tr>

<tr>
  <td colspan="3">MEXICAN PANINI S/W</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">MELTED CHEESE PANINI S/W</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">200</td>
</tr>

<tr>
  <td colspan="3">CHEESE MAYO GARLIC BREAD</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">CHEESE HARA BHARA KABAB ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Pizza</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">DELUXE VEGGIE PIZZA (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">CLASSIC MARGARITA PIZZA (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">PEPPY PANEER CHEESE BURST PIZZA</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">200</td>
</tr>
        </table>
    );
  },
  cafe4: () => {
    return (
      <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe5: () => {
    return (
       <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src="" />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">Café Day Express</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">AMERICANO_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">CAFE LATTE_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">CAPPUCCINO_ LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">ESPRESSO_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">CAF _MOCHA</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">CHOCOLATE_MOKSHA</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">HEALTH DRINK</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BADAM MILK_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">BOOST_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">HORLICKS_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">CARDAMOM CHAI_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">LEMON CHAI_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">MASALA CHAI_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">GARAM CHAI_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">GINGER CHAI_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">GREEN TEA_LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">200 ML</td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FILTER COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">FCTM-FILTER COFFEE - LARGE</td><td class="ft-Wt-700">120.00</td><td class="ft-Wt-700">180 ML</td></tr>
<tr><td colspan="3">FCTM-FILTER COFFEE - SMALL</td><td class="ft-Wt-700">60.00</td><td class="ft-Wt-700">110 ML</td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FRESH TEA</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">FCTM-KADAK CHAI - LARGE</td><td class="ft-Wt-700">100.00</td><td class="ft-Wt-700">180 ML</td></tr>
<tr><td colspan="3">FCTM-KADAK CHAI - SMALL</td><td class="ft-Wt-700">60.00</td><td class="ft-Wt-700">110 ML</td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">COLD BEVERAGE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">COLD_CHOCO</td><td class="ft-Wt-700">150.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">ESKIMO_COFFEE</td><td class="ft-Wt-700">150.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">LEMON ICED_TEA</td><td class="ft-Wt-700">150.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">ORANGILLO_</td><td class="ft-Wt-700">150.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">TROPICAL_MOKSHA</td><td class="ft-Wt-700">150.00</td><td class="ft-Wt-700">200 ML</td></tr>
<tr><td colspan="3">CLASSIC COLD COFFEE</td><td class="ft-Wt-700">160.00</td><td class="ft-Wt-700">180 ML</td></tr>
<tr><td colspan="3">HAZELNUT COLD COFFEE</td><td class="ft-Wt-700">160.00</td><td class="ft-Wt-700">180 ML</td></tr>
<tr><td colspan="3">CLASSIC CHOCOLATE MILKSHAKE</td><td class="ft-Wt-700">160.00</td><td class="ft-Wt-700">180 ML</td></tr>
<tr><td colspan="3">BERRY MILKSHAKE</td><td class="ft-Wt-700">160.00</td><td class="ft-Wt-700">180 ML</td></tr>

<tr><td colspan="3">WATER_COFFEE DAY</td><td class="ft-Wt-700">MRP</td><td></td></tr>
<tr><td colspan="3">MINERAL WATER 1 LTR</td><td class="ft-Wt-700">MRP</td><td></td></tr>
<tr><td colspan="3">SOUL NATURAL MINARAL WATER-MRP-60-X</td><td class="ft-Wt-700">MRP</td><td></td></tr>

 <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BUN MASKA</td><td class="ft-Wt-700">110</td><td class="ft-Wt-700">70 GRM</td></tr>
<tr><td colspan="3">CLASSIC GARLIC BREAD</td><td class="ft-Wt-700">110</td><td class="ft-Wt-700">90 GRM</td></tr>
<tr><td colspan="3">COCOA FANTASY PASTRY</td><td class="ft-Wt-700">160</td><td class="ft-Wt-700">100 GRM</td></tr>
<tr><td colspan="3">FLAKY VEG PUFF</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">100 GRM</td></tr>
<tr><td colspan="3">SAMOSA</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">100 GRM</td></tr>
<tr><td colspan="3">SPINACH N CORN CHEESE SANDWICH</td><td class="ft-Wt-700">160</td><td class="ft-Wt-700">120 GRM</td></tr>
<tr><td colspan="3">TANDOORI PANEER SANDWICH</td><td class="ft-Wt-700">160</td><td class="ft-Wt-700">120 GRM</td></tr>
<tr><td colspan="3">VADA PAV</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">80 GRM</td></tr>
        </table>
    );
  },
  cafe6: () => {
    return (
      <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe7: () => {
    return (
     <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe8: () => {
    return (
       <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe9: () => {
    return (
     <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe10: () => {
    return (
    <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={society} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">SOCIETY TEA TERMINAL</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">REGULER TEA</td>
  <td class="ft-Wt-700">50</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr>
  <td colspan="3">MASALA TEA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr>
  <td colspan="3">ELAICHI TEA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">RTD ICED TEA</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">PEACH & APRICOT</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">LEMON</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CINNAMON BERGAMOT</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">CAMAMILE JASMINE</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">STRAWBERRY KIWI LEMONGRASS</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">ORANGE GINGER LEMONGRASS</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">2 BOTTEL ANY FLAVOUR</td>
  <td class="ft-Wt-700">100</td>
  <td class="ft-Wt-700">500ML</td>
</tr>

<tr>
  <td colspan="3">4 BOTTEL ANY FLAVOUR</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">1000ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">100</td>
  <td class="ft-Wt-700">250ML</td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr>
  <td colspan="3">BLACK COFFEE</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">DETOX SERIES</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">GREEN TEA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">KASMIRI KAHWA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">TULSI RITUAL</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">MOROCCAN MINT</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">FLOWERY BOUQUET</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">SOOTHING CHAMOMILE</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">DIVINE DARJEELING</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">200ML</td>
</tr>

<tr>
  <td colspan="3">CLEANSE</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr>
  <td colspan="3">HALDI DOODH</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KHARI (3 PCS)</td>
  <td class="ft-Wt-700">40</td>
  <td class="ft-Wt-700">3 PCS</td>
</tr>

<tr>
  <td colspan="3">TOAST (3 PCS)</td>
  <td class="ft-Wt-700">40</td>
  <td class="ft-Wt-700">3 PCS</td>
</tr>

<tr>
  <td colspan="3">BUN JAM MASKA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">1 PC</td>
</tr>
<tr>
  <td colspan="3">POHA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">60GM</td>
</tr>
<tr>
  <td colspan="3">UPMA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">60GM</td>
</tr>
<tr>
  <td colspan="3">Maggi</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">60GM</td>
</tr>
        </table>
    );
  },
  cafe11: () => {
    return (
      <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={highness} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HIGHNESS PANINI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks & Bakery</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MEXICAN (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">200 Gms</td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">200 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE MELT PANINI (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">250 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE MAYO GARLIC BREAD</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700">120 Gms</td>
</tr>

<tr>
  <td colspan="3">VEG GRILLED SANDWICH (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">280 Gms</td>
</tr>

<tr>
  <td colspan="3">MELTED SANDWICH (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">280 Gms</td>
</tr>

<tr>
  <td colspan="3">MASKA BUN</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">50 Gms</td>
</tr>

<tr>
  <td colspan="3">JAM BUN</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">50 Gms</td>
</tr>

<tr>
  <td colspan="3">CHEESE CHILLY SANDWICH</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">250 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Pizza</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MARGARITA PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">140 Gms</td>
</tr>

<tr>
  <td colspan="3">PEPPY PANEER PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 Gms</td>
</tr>

<tr>
  <td colspan="3">FARMHOUSE PIZZA (JAIN/REGULAR)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Roll</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA ROLL</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700">150 Gms</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Beverages</td>
  <td></td>
  <td></td>
</tr>



<tr>
  <td colspan="3">MASALA TEA</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">BLACK TEA</td>
  <td class="ft-Wt-700">50</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">LEMON TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">GREEN TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">COFFEE</td>
  <td class="ft-Wt-700">80</td>
  <td class="ft-Wt-700">100 Ml</td>
</tr>

<tr>
  <td colspan="3">CAFE AMERICANO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr>
  <td colspan="3">EXPRESSO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">200 Ml</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">SIGNATURE MOCHA COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">SIGNATURE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">SIGNATURE ICE AMERICANO</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">LEMON ICED TEA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>

<tr>
  <td colspan="3">PEACH ICED TEA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 Ml</td>
</tr>
        </table>
    );
  },
  cafe12: () => {
    return (
    <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={cafeBrew} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">CAFE BREW STUDIO</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">CAFÉ LATTE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">CAFÉ MOCHA</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">AMERICANO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">HOT CHOCOLATE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250</td>
</tr>

<tr>
  <td colspan="3">MASALA TEA</td>
  <td class="ft-Wt-700">70</td>
  <td class="ft-Wt-700">140</td>
</tr>


<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300</td>
</tr>

<tr>
  <td colspan="3">ICE CHOCOLATE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">300</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Sandwich</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VEG GRILLED SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">VEG CHEESE GRILLED S/W (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">150</td>
</tr>



<tr>
  <td colspan="3">BBQ PANEER WRAP</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">210</td>
</tr>

<tr>
  <td colspan="3">MEXICAN PANINI S/W</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">MELTED CHEESE PANINI S/W</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">200</td>
</tr>

<tr>
  <td colspan="3">CHEESE MAYO GARLIC BREAD</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">CHEESE HARA BHARA KABAB ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Pizza</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">DELUXE VEGGIE PIZZA (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">CLASSIC MARGARITA PIZZA (JAIN / REGULAR)</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">PEPPY PANEER CHEESE BURST PIZZA</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">200</td>
</tr>
        </table>
    );
  },
  cafe13: () => {
    return (
     <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={barista} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">BARISTA</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>PRICE</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td colspan="3" class="ft-Wt-700">BEVERAGES</td>
  <td></td>
  <td></td>
</tr>

<tr class="spacer">
  <td colspan="3" class="ft-Wt-700">HOT CLASSICS</td>
  <td class="ft-Wt-700">Small</td>
  <td class="ft-Wt-700">Regular</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr><td colspan="3">CAFÉ AMERICANO</td><td class="ft-Wt-700">160</td><td class="ft-Wt-700">180</td></tr>
<tr><td colspan="3">CAPPUCCINO</td><td class="ft-Wt-700">200</td><td class="ft-Wt-700">230</td></tr>
<tr><td colspan="3">CAFÉ LATTE</td><td class="ft-Wt-700">210</td><td class="ft-Wt-700">230</td></tr>
<tr><td colspan="3">FLAT WHITE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">250</td></tr>
<tr><td colspan="3">CAFÉ MOCHA</td><td class="ft-Wt-700">230</td><td class="ft-Wt-700">260</td></tr>
<tr><td colspan="3">HOT CHOCOLATE</td><td class="ft-Wt-700">240</td><td class="ft-Wt-700">270</td></tr>
<tr><td colspan="3">ESPRESSO ITALIANO</td><td class="ft-Wt-700">140</td><td class="ft-Wt-700">170</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">COLD CLASSICS</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BRRRISTA BLAST</td><td class="ft-Wt-700">320</td><td class="ft-Wt-700">360</td></tr>
<tr><td colspan="3">BRRRISTA FRAPPE</td><td class="ft-Wt-700">310</td><td class="ft-Wt-700"></td></tr>
<tr><td colspan="3">CHOCOLATE SMOOTHIE</td><td class="ft-Wt-700">260</td><td class="ft-Wt-700">320</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">ICED BLENDED / GRANITAS</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">ICED LATTE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">250</td></tr>
<tr><td colspan="3">ICED AMERICANO</td><td class="ft-Wt-700">200</td><td class="ft-Wt-700">230</td></tr>
<tr><td colspan="3">BRRRISTA</td><td class="ft-Wt-700">200</td><td class="ft-Wt-700">230</td></tr>
<tr><td colspan="3">ICED CAFÉ MOCHA</td><td class="ft-Wt-700">240</td><td class="ft-Wt-700">280</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEAS @200</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">GINGER HONEY TEA</td><td class="ft-Wt-700">180</td><td class="ft-Wt-700"></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FOOD</td>
  <td></td>
  <td></td>
</tr>

<tr class="spacer">
  <td class="ft-Wt-700">COFFEE COMPANION</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">DOUBLE CHOCOLATE CHIP COOKIE</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">OATMEAL RAISIN COOKIE</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">CHOCO CHIP MUFFIN</td><td class="ft-Wt-700">225</td><td></td></tr>
<tr><td colspan="3">BLUEBERRY MUFFIN</td><td class="ft-Wt-700">225</td><td></td></tr>
<tr><td colspan="3">INDULGENT ALMOND MUFFIN</td><td class="ft-Wt-700">225</td><td></td></tr>
<tr><td colspan="3">MARBLE CAKE</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">SPINACH CORN SANDWICH</td><td class="ft-Wt-700">275</td><td></td></tr>
<tr><td colspan="3">PANNER TIKKA SANDWICH</td><td class="ft-Wt-700">275</td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">QUICK BITES</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">THREE PEPPER CHEESE TOASTIE</td><td class="ft-Wt-700">175</td><td></td></tr>
<tr><td colspan="3">VEG PUFF</td><td class="ft-Wt-700">150</td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">WRAPS</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">ACHARI PANEER</td><td class="ft-Wt-700">275</td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">DESSERTS</td>
  <td></td>
  <td></td>
</tr>

<tr class="spacer">
  <td class="ft-Wt-700">INDULGENT DESSERTS</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">DARK TEMPTATION</td><td class="ft-Wt-700">350</td><td></td></tr>
<tr><td colspan="3">WICKED BROWNIE</td><td class="ft-Wt-700">350</td><td></td></tr>
<tr><td colspan="3">CHOCOLATE EXCESS</td><td class="ft-Wt-700">250</td><td></td></tr>
<tr><td colspan="3">BROWNIE FONDANT</td><td class="ft-Wt-700">250</td><td></td></tr>
        </table>
    );
  },
  cafe14: () => {
    return (
       <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={hatti}/>
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">HATTI KAPPI</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">KAAPI</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">KAAPI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">KAAPI LARGE</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">BELLA KAAPI LARGE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">CHAIS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GINGER CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">LEMON CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr>
  <td colspan="3">GREEN CHAI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">250 ML</td>
</tr>

<tr>
  <td colspan="3">BADAM MILK</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">180 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">COLD COFFEE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD BADAM MILK</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr>
  <td colspan="3">COLD LEMON CHAI</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>



<tr>
  <td colspan="3">CHOCOLATE COLD COFFEE</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">300 ML</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Food</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALOO MASALA SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">SABUDANA VADA (2 PCS)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>

<tr>
  <td colspan="3">PANEER WRAP</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE DOUGHNUTS (1 PC)</td>
  <td class="ft-Wt-700">120</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MIX VEG WRAP</td>
  <td class="ft-Wt-700">170</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">ACHARI TOFU WRAP</td>
  <td class="ft-Wt-700">190</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">SPINACH & CORN SANDWICH</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">150 GMS</td>
</tr>

<tr>
  <td colspan="3">PEPPER MUSHROOM</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">200 GMS</td>
</tr>

<tr>
  <td colspan="3">TANDOORI TIKKA SUB SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">KAAPI BROWNIE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">100 GMS</td>
</tr>
<tr>
  <td colspan="3">KOREAN BUNS (1PC)</td>
  <td class="ft-Wt-700">140</td>
  <td class="ft-Wt-700">90 GMS</td>
</tr>
<tr>
  <td colspan="3">BANANA CAKE (1 PC)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">125 GMS</td>
</tr>
<tr>
  <td colspan="3">BLACK FOREST CAKE</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"></td>
</tr>
<tr>
  <td colspan="3">MUFFIN CHOCOLATE</td>
  <td class="ft-Wt-700">110</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Kaapi Powder Tube (250 GM)</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">CHICORY BLEND (80:20)</td>
  <td class="ft-Wt-700">320</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">270</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">MYSORE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">200 GM</td>
</tr>

<tr>
  <td colspan="3">PURE KAAPI</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">250 GM</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

<tr class="spacer">
  <td class="ft-Wt-700">Jain Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MASALA VADA (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">BALEKAI BAJJI (3 PCS)</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SAMOSA (2 PCS)</td>
  <td class="ft-Wt-700">130</td>
  <td class="ft-Wt-700">130</td>
</tr>

<tr>
  <td colspan="3">JAIN ROLLS</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>

<tr>
  <td colspan="3">JAIN SANDWICH</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700">180</td>
</tr>

<tr>
  <td colspan="3">JAIN BURGER</td>
  <td class="ft-Wt-700">160</td>
  <td class="ft-Wt-700">160</td>
</tr>

<tr>
  <td colspan="3">KACHORI</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700">150</td>
</tr>
        </table>
    );
  },
  cafe15: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={subway} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">SUBWAY</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>

 <tr class="spacer">
  <td class="ft-Wt-700">Sub</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VEGGIE DELITE SUB</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">15 cm</td>
</tr>

<tr>
  <td colspan="3">ALOO PATTY SUB</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">15 cm</td>
</tr>

<tr>
  <td colspan="3">CHILLI BEAN PATTY SUB</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700">15 cm</td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA SUB</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">15 cm</td>
</tr>

<tr>
  <td colspan="3">ALOO PATTY RICE BOWL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">PANEER TIKKA RICE BOWL</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">LATTE</td>
  <td class="ft-Wt-700">150</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">COOKIE</td>
  <td class="ft-Wt-700">100</td>
  <td class="ft-Wt-700"></td>
</tr>
        </table>
      </>
    );
  },
  cafe16: () => {
    return (
      <>
         <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={blue} />
            </td>
          </tr>
          <tr class="title">
            <td colspan="6">BLUE TOKAI COFFEE</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>GM/ML</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Hot Brews</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ESPRESSO</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">AMERICANO</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">CORTADO</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">FLAT WHITE</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">CAPPUCCINO</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">LATTE</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">REGULAR MOCHA</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr>
  <td colspan="3">HOT CHOCOLATE</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">300ml</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Brews</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ICED ESPRESSO</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700">380ml</td>
</tr>

<tr>
  <td colspan="3">ICED AMERICANO</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">380ml</td>
</tr>

<tr>
  <td colspan="3">ICED LATTE</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">380ml</td>
</tr>

<tr>
  <td colspan="3">VIETNAMESE STYLE ICED COFFEE</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">380ml</td>
</tr>

<tr>
  <td colspan="3">ICED CAPPUCCINO</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700">380ml</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Fresh Bakes By Suchali's</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">ALMOND, OATS AND CHOCO CHIP COOKIES</td>
  <td class="ft-Wt-700">100</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">BROWNIE CRINKLE COOKIE</td>
  <td class="ft-Wt-700">100</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">TRADITIONAL BUTTER CROISSANT</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">ALMOND CROISSANT</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE AND SALTED CARAMEL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MUSHROOM CREAM CHEESE CROISSTATA</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHICKEN FLORENTINE FLATBREAD</td>
  <td class="ft-Wt-700">350</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">MOCHA BROWNIE</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cold Brew In Can</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">CLASSIC BOLD</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CLASSIC LIGHT</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Cookies (Pack of 10) by Suchali's</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">MULTI SEED MILLET COOKIES</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">OAT MEAL AND CRANBERRY COOKIES</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">WHEAT BRAN COCONUT COOKIES</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">CHOCOLATE CHIP COOKIES</td>
  <td class="ft-Wt-700">220</td>
  <td class="ft-Wt-700"></td>
</tr>
        </table>
      </>
    );
  },
  eliteCafe1: () => {
    return (
      <>
         <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          {/* <tr className="cafe-container">
            <td colSpan={9} className="cafe-logo">
              <img className="cafe-img" src={blue} />
            </td>
          </tr> */}
          <tr class="title">
            <td colspan="6">GENERAL CAFETERIA & VIP CAFETERIA - MENU</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>Portion</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VADA PAV</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700"> 100 gm  1 Pcs Pav, Powder Lassun Chutney., potato/kela stuffing</td>
</tr>

<tr>
  <td colspan="3">DELHI SAMOSA (2PCS)</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">90 gm 1 Pcs Tomato Ketchup, potato & green peas stuffing</td>
</tr>

<tr>
  <td colspan="3">GRILLED CHEESE SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">7''*5''*5 Tomato Ketchup, double layered  & stuffed with cheese & grilled</td>
</tr>

<tr>
  <td colspan="3">PAVBHAJI (2 PAV)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 gm bhaji Chopped Onions & Lime</td>
</tr>

<tr>
  <td colspan="3">EXTRA MASALA PAV (1PCS)</td>
  <td class="ft-Wt-700">30</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SOUTH INDIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">STEAM IDLI (2PCS) SAMBHAR / CHUTNEY</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"> 75 gm each 3.5 inch approx Sambhar & Chutney</td>
</tr>

<tr>
  <td colspan="3">SADA DOSA</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, made in butter</td>
</tr>

<tr>
  <td colspan="3">MASALA DOSA</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, aloo masala made in butter</td>
</tr>

<tr>
  <td colspan="3">JINI DOSA</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">LEBENESE</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FALAFEL ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">Size 7 inch, 2 Bullets, Pickled Veggie, Hummus, Tahini, Mayonnaise, Harissa Sauce.</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">ITALIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">THIN CRUST PIZZA WITH ALL TOPPINGS (9 INCH)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700"></td>
</tr>


<tr class="spacer">
  <td class="ft-Wt-700">COMBO MEALS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FULL MEALS (2 VEG, 2 ROTI, DAL, RICE & PICKLE)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700">100gm Vegetable, 2 roti's at 5.5", dal 200gm, rice 150 gm,& Pickle</td>
</tr>

<tr>
  <td colspan="3">CHOLE KULCHA</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">150 gm chole 5.5'' kulcha served with amritsari chutney & kachumber</td>
</tr>

<tr>
  <td colspan="3">EXTRA KULCHA (1 PC)</td>
  <td class="ft-Wt-700">90</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">FRIED RICE WITH MANCHURIAN</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">220 gm rice & 150 ml gravy 4 balls of manchurian</td>
</tr>

<tr>
  <td colspan="3">BIRYANI WITH MIX VEG RAITA</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">200 gm with Raita</td>
</tr>

<tr>
  <td colspan="3">CURD RICE</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">RASAM RICE</td>
  <td class="ft-Wt-700"></td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FRESH JUICES</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SUGAR CANE JUICE</td><td class="ft-Wt-700">120</td><td class="ft-Wt-700">220 ml</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA / COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COFFEE</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">130 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (600ML PET BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">1 Liter</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">VIP / Elite Café</td>
  <td></td>
  <td></td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BHEL PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">SEV PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">TAATH IDLI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">PLAIN VEGETABLE MAGGI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">CHEESE VEGETABLE MAGGI</td><td class="ft-Wt-700">180</td><td></td></tr>
<tr><td colspan="3">KHICHIYU</td><td class="ft-Wt-700">160</td><td></td></tr>
<tr><td colspan="3">BEETROOT MALAWACH WRAP</td><td class="ft-Wt-700">300</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI WITH FAFDA</td><td class="ft-Wt-700">250</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">LEBNESE PIZZA (6 INCH)</td><td class="ft-Wt-700"></td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (200 ml PER BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER (1 LTR)</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">MRP</td></tr>
        </table>
      </>
    );
  },
  eliteCafe2: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          
          <tr class="title">
            <td colspan="6">GENERAL CAFETERIA & VIP CAFETERIA - MENU</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>Portion</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VADA PAV</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700"> 100 gm  1 Pcs Pav, Powder Lassun Chutney., potato/kela stuffing</td>
</tr>

<tr>
  <td colspan="3">DELHI SAMOSA (2PCS)</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">90 gm 1 Pcs Tomato Ketchup, potato & green peas stuffing</td>
</tr>

<tr>
  <td colspan="3">GRILLED CHEESE SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">7''*5''*5 Tomato Ketchup, double layered  & stuffed with cheese & grilled</td>
</tr>

<tr>
  <td colspan="3">PAVBHAJI (2 PAV)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 gm bhaji Chopped Onions & Lime</td>
</tr>

<tr>
  <td colspan="3">EXTRA MASALA PAV (1PCS)</td>
  <td class="ft-Wt-700">30</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SOUTH INDIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">STEAM IDLI (2PCS) SAMBHAR / CHUTNEY</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"> 75 gm each 3.5 inch approx Sambhar & Chutney</td>
</tr>

<tr>
  <td colspan="3">SADA DOSA</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, made in butter</td>
</tr>

<tr>
  <td colspan="3">MASALA DOSA</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, aloo masala made in butter</td>
</tr>

<tr>
  <td colspan="3">JINI DOSA</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">LEBENESE</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FALAFEL ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">Size 7 inch, 2 Bullets, Pickled Veggie, Hummus, Tahini, Mayonnaise, Harissa Sauce.</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">ITALIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">THIN CRUST PIZZA WITH ALL TOPPINGS (9 INCH)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700"></td>
</tr>


<tr class="spacer">
  <td class="ft-Wt-700">COMBO MEALS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FULL MEALS (2 VEG, 2 ROTI, DAL, RICE & PICKLE)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700">100gm Vegetable, 2 roti's at 5.5", dal 200gm, rice 150 gm,& Pickle</td>
</tr>

<tr>
  <td colspan="3">CHOLE KULCHA</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">150 gm chole 5.5'' kulcha served with amritsari chutney & kachumber</td>
</tr>

<tr>
  <td colspan="3">EXTRA KULCHA (1 PC)</td>
  <td class="ft-Wt-700">90</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">FRIED RICE WITH MANCHURIAN</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">220 gm rice & 150 ml gravy 4 balls of manchurian</td>
</tr>

<tr>
  <td colspan="3">BIRYANI WITH MIX VEG RAITA</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">200 gm with Raita</td>
</tr>

<tr>
  <td colspan="3">CURD RICE</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">RASAM RICE</td>
  <td class="ft-Wt-700"></td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FRESH JUICES</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SUGAR CANE JUICE</td><td class="ft-Wt-700">120</td><td class="ft-Wt-700">220 ml</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA / COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COFFEE</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">130 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (600ML PET BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">1 Liter</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">VIP / Elite Café</td>
  <td></td>
  <td></td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BHEL PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">SEV PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">TAATH IDLI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">PLAIN VEGETABLE MAGGI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">CHEESE VEGETABLE MAGGI</td><td class="ft-Wt-700">180</td><td></td></tr>
<tr><td colspan="3">KHICHIYU</td><td class="ft-Wt-700">160</td><td></td></tr>
<tr><td colspan="3">BEETROOT MALAWACH WRAP</td><td class="ft-Wt-700">300</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI WITH FAFDA</td><td class="ft-Wt-700">250</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">LEBNESE PIZZA (6 INCH)</td><td class="ft-Wt-700"></td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (200 ml PER BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER (1 LTR)</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">MRP</td></tr>
        </table>
      </>
    );
  },
  eliteCafe3: () => {
    return (
      <>
        <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
          
          <tr class="title">
            <td colspan="6">GENERAL CAFETERIA & VIP CAFETERIA - MENU</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>Portion</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VADA PAV</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700"> 100 gm  1 Pcs Pav, Powder Lassun Chutney., potato/kela stuffing</td>
</tr>

<tr>
  <td colspan="3">DELHI SAMOSA (2PCS)</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">90 gm 1 Pcs Tomato Ketchup, potato & green peas stuffing</td>
</tr>

<tr>
  <td colspan="3">GRILLED CHEESE SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">7''*5''*5 Tomato Ketchup, double layered  & stuffed with cheese & grilled</td>
</tr>

<tr>
  <td colspan="3">PAVBHAJI (2 PAV)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 gm bhaji Chopped Onions & Lime</td>
</tr>

<tr>
  <td colspan="3">EXTRA MASALA PAV (1PCS)</td>
  <td class="ft-Wt-700">30</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SOUTH INDIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">STEAM IDLI (2PCS) SAMBHAR / CHUTNEY</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"> 75 gm each 3.5 inch approx Sambhar & Chutney</td>
</tr>

<tr>
  <td colspan="3">SADA DOSA</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, made in butter</td>
</tr>

<tr>
  <td colspan="3">MASALA DOSA</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, aloo masala made in butter</td>
</tr>

<tr>
  <td colspan="3">JINI DOSA</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">LEBENESE</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FALAFEL ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">Size 7 inch, 2 Bullets, Pickled Veggie, Hummus, Tahini, Mayonnaise, Harissa Sauce.</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">ITALIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">THIN CRUST PIZZA WITH ALL TOPPINGS (9 INCH)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700"></td>
</tr>


<tr class="spacer">
  <td class="ft-Wt-700">COMBO MEALS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FULL MEALS (2 VEG, 2 ROTI, DAL, RICE & PICKLE)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700">100gm Vegetable, 2 roti's at 5.5", dal 200gm, rice 150 gm,& Pickle</td>
</tr>

<tr>
  <td colspan="3">CHOLE KULCHA</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">150 gm chole 5.5'' kulcha served with amritsari chutney & kachumber</td>
</tr>

<tr>
  <td colspan="3">EXTRA KULCHA (1 PC)</td>
  <td class="ft-Wt-700">90</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">FRIED RICE WITH MANCHURIAN</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">220 gm rice & 150 ml gravy 4 balls of manchurian</td>
</tr>

<tr>
  <td colspan="3">BIRYANI WITH MIX VEG RAITA</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">200 gm with Raita</td>
</tr>

<tr>
  <td colspan="3">CURD RICE</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">RASAM RICE</td>
  <td class="ft-Wt-700"></td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FRESH JUICES</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SUGAR CANE JUICE</td><td class="ft-Wt-700">120</td><td class="ft-Wt-700">220 ml</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA / COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COFFEE</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">130 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (600ML PET BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">1 Liter</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">VIP / Elite Café</td>
  <td></td>
  <td></td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BHEL PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">SEV PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">TAATH IDLI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">PLAIN VEGETABLE MAGGI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">CHEESE VEGETABLE MAGGI</td><td class="ft-Wt-700">180</td><td></td></tr>
<tr><td colspan="3">KHICHIYU</td><td class="ft-Wt-700">160</td><td></td></tr>
<tr><td colspan="3">BEETROOT MALAWACH WRAP</td><td class="ft-Wt-700">300</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI WITH FAFDA</td><td class="ft-Wt-700">250</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">LEBNESE PIZZA (6 INCH)</td><td class="ft-Wt-700"></td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (200 ml PER BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER (1 LTR)</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">MRP</td></tr>
        </table>
      </>
    );
  },
  eliteCafe4: () => {
    return (
      <>
         <table>
          <tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
         
          <tr class="title">
            <td colspan="6">GENERAL CAFETERIA & VIP CAFETERIA - MENU</td>
          </tr>
          <tr class="head">
  <td colspan="3">Item</td>
  <td>PRICE</td>
  <td>Portion</td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SNACKS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">VADA PAV</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700"> 100 gm  1 Pcs Pav, Powder Lassun Chutney., potato/kela stuffing</td>
</tr>

<tr>
  <td colspan="3">DELHI SAMOSA (2PCS)</td>
  <td class="ft-Wt-700">60</td>
  <td class="ft-Wt-700">90 gm 1 Pcs Tomato Ketchup, potato & green peas stuffing</td>
</tr>

<tr>
  <td colspan="3">GRILLED CHEESE SANDWICH</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">7''*5''*5 Tomato Ketchup, double layered  & stuffed with cheese & grilled</td>
</tr>

<tr>
  <td colspan="3">PAVBHAJI (2 PAV)</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">170 gm bhaji Chopped Onions & Lime</td>
</tr>

<tr>
  <td colspan="3">EXTRA MASALA PAV (1PCS)</td>
  <td class="ft-Wt-700">30</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">SOUTH INDIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">STEAM IDLI (2PCS) SAMBHAR / CHUTNEY</td>
  <td class="ft-Wt-700">200</td>
  <td class="ft-Wt-700"> 75 gm each 3.5 inch approx Sambhar & Chutney</td>
</tr>

<tr>
  <td colspan="3">SADA DOSA</td>
  <td class="ft-Wt-700">180</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, made in butter</td>
</tr>

<tr>
  <td colspan="3">MASALA DOSA</td>
  <td class="ft-Wt-700">240</td>
  <td class="ft-Wt-700"> 14''*12'' Sambhar & Chutney, aloo masala made in butter</td>
</tr>

<tr>
  <td colspan="3">JINI DOSA</td>
  <td class="ft-Wt-700">250</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">LEBENESE</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FALAFEL ROLL</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">Size 7 inch, 2 Bullets, Pickled Veggie, Hummus, Tahini, Mayonnaise, Harissa Sauce.</td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">ITALIAN</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">THIN CRUST PIZZA WITH ALL TOPPINGS (9 INCH)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700"></td>
</tr>


<tr class="spacer">
  <td class="ft-Wt-700">COMBO MEALS</td>
  <td></td>
  <td></td>
</tr>

<tr>
  <td colspan="3">FULL MEALS (2 VEG, 2 ROTI, DAL, RICE & PICKLE)</td>
  <td class="ft-Wt-700">450</td>
  <td class="ft-Wt-700">100gm Vegetable, 2 roti's at 5.5", dal 200gm, rice 150 gm,& Pickle</td>
</tr>

<tr>
  <td colspan="3">CHOLE KULCHA</td>
  <td class="ft-Wt-700">380</td>
  <td class="ft-Wt-700">150 gm chole 5.5'' kulcha served with amritsari chutney & kachumber</td>
</tr>

<tr>
  <td colspan="3">EXTRA KULCHA (1 PC)</td>
  <td class="ft-Wt-700">90</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">FRIED RICE WITH MANCHURIAN</td>
  <td class="ft-Wt-700">300</td>
  <td class="ft-Wt-700">220 gm rice & 150 ml gravy 4 balls of manchurian</td>
</tr>

<tr>
  <td colspan="3">BIRYANI WITH MIX VEG RAITA</td>
  <td class="ft-Wt-700">280</td>
  <td class="ft-Wt-700">200 gm with Raita</td>
</tr>

<tr>
  <td colspan="3">CURD RICE</td>
  <td class="ft-Wt-700">230</td>
  <td class="ft-Wt-700"></td>
</tr>

<tr>
  <td colspan="3">RASAM RICE</td>
  <td class="ft-Wt-700"></td>
  <td class="ft-Wt-700"></td>
</tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">FRESH JUICES</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SUGAR CANE JUICE</td><td class="ft-Wt-700">120</td><td class="ft-Wt-700">220 ml</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">TEA / COFFEE</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COFFEE</td><td class="ft-Wt-700">70</td><td class="ft-Wt-700">130 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (600ML PET BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">1 Liter</td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">VIP / Elite Café</td>
  <td></td>
  <td></td>
</tr>
<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Snacks</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">BHEL PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">SEV PURI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">TAATH IDLI</td><td class="ft-Wt-700">200</td><td></td></tr>
<tr><td colspan="3">PLAIN VEGETABLE MAGGI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">CHEESE VEGETABLE MAGGI</td><td class="ft-Wt-700">180</td><td></td></tr>
<tr><td colspan="3">KHICHIYU</td><td class="ft-Wt-700">160</td><td></td></tr>
<tr><td colspan="3">BEETROOT MALAWACH WRAP</td><td class="ft-Wt-700">300</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI WITH FAFDA</td><td class="ft-Wt-700">250</td><td></td></tr>
<tr><td colspan="3">KESAR JALEBI</td><td class="ft-Wt-700">150</td><td></td></tr>
<tr><td colspan="3">LEBNESE PIZZA (6 INCH)</td><td class="ft-Wt-700"></td><td></td></tr>

<tr className="spacer">
            <td></td>
            <td></td>
            <td></td>
          </tr>
<tr class="spacer">
  <td class="ft-Wt-700">Beverages</td>
  <td></td>
  <td></td>
</tr>

<tr><td colspan="3">WATERMELON</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">PINEAPPLE</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">COCKTAIL</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">SWEAT LIME</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">MARAMARI</td><td class="ft-Wt-700">220</td><td class="ft-Wt-700">220 ml</td></tr>
<tr><td colspan="3">TEA - SMALL</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">100 ml</td></tr>
<tr><td colspan="3">COLD-DRINKS (200 ml PER BOTTLES)</td><td class="ft-Wt-700">50</td><td class="ft-Wt-700">200 ml</td></tr>
<tr><td colspan="3">MINERAL WATER (1 LTR)</td><td class="ft-Wt-700">25</td><td class="ft-Wt-700">MRP</td></tr>
        </table>
      </>
    );
  },

};
